// src/pages/product/TeamPage.js
import FeaturePageTemplate from './FeaturePageTemplate';

export default function TeamPage() {
  return <FeaturePageTemplate slug="team" />;
}